document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-anya-contact]').forEach((form) => {
    const W = JSON.parse(document.querySelector('[data-anya-runtime]')?.textContent || '{}');
    const status = form.querySelector('[data-contact-status]');
    const requiredFields = [...form.querySelectorAll('[required]')];

    const clearFieldError = (field) => field.removeAttribute('aria-invalid');
    requiredFields.forEach((field) => {
      field.addEventListener('input', () => clearFieldError(field));
      field.addEventListener('change', () => clearFieldError(field));
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const firstName = String(data.get('first_name') || '').trim();
      const subject = form.querySelector('[name="subject"]')?.selectedOptions[0]?.textContent.trim() || '';
      const customerPhone = String(data.get('phone') || '').trim();
      const orderNumber = String(data.get('order_number') || '').trim();
      const message = String(data.get('message') || '').trim();
      const number = String(form.dataset.whatsappNumber || '').replace(/\D/g, '');
      const invalidFields = requiredFields.filter((field) => !String(field.value || '').trim());

      if (invalidFields.length || !firstName || !customerPhone || !data.get('subject') || !subject || !message || !number) {
        invalidFields.forEach((field) => field.setAttribute('aria-invalid', 'true'));
        status.textContent = form.dataset.i18nError || 'Merci de renseigner votre nom, votre téléphone, le sujet et votre message.';
        invalidFields[0]?.focus();
        return;
      }

      const lines = [
        W.greeting,
        '',
        `${W.name} : ${firstName}`,
        `${W.phone} : ${customerPhone}`,
        `${W.subject} : ${subject}`,
        orderNumber ? `${W.order} : ${orderNumber}` : '',
        '',
        `${W.message} :`,
        message,
        '',
        W.advisor
      ].filter(Boolean);

      status.textContent = form.dataset.i18nOpening || 'Ouverture de WhatsApp…';
      window.open(`https://wa.me/${number}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank', 'noopener,noreferrer');
    });
  });
});
